import React, { useState, useEffect } from "react";
import { Share2, X, Copy, Facebook, Twitter, Mail, MessageCircle, Check } from "lucide-react";
import api from "@/lib/api";

export default function ShareModal({ propertyId, open, onClose }) {
    const [data, setData] = useState(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (open && propertyId) {
            api.get(`/share/${propertyId}`).then((r) => setData(r.data));
        }
    }, [open, propertyId]);

    if (!open) return null;

    const url = data?.share_url || "";
    const text = data?.share_text || "";
    const enc = (s) => encodeURIComponent(s);

    const networks = [
        { label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
        { label: "Twitter / X", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}` },
        { label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${enc(text + " " + url)}` },
        { label: "Email", icon: Mail, href: `mailto:?subject=${enc(data?.title || "Annuncio")}&body=${enc(text + "\n\n" + url)}` },
    ];

    const copy = async () => {
        await navigator.clipboard.writeText(`${text}\n${url}`);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div data-testid="share-modal" className="fixed inset-0 z-50 bg-black/70 backdrop-blur-md flex items-center justify-center p-6" onClick={onClose}>
            <div className="bg-ink-950 border border-gold/40 max-w-lg w-full p-10" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-6">
                    <span className="label-eyebrow">Condividi annuncio</span>
                    <button onClick={onClose} data-testid="share-close" className="text-ink-400 hover:text-gold"><X size={18} /></button>
                </div>
                <h3 className="font-serif text-2xl text-ink-50 mb-2">Sponsorizza in modo anonimo</h3>
                <p className="text-sm text-ink-400 mb-6">Il messaggio non contiene i tuoi contatti — solo dettagli immobile e il link a vendidirect.it.</p>

                {data?.photo && (
                    <div className="aspect-[16/9] overflow-hidden border border-white/10 mb-6 relative">
                        <img src={data.photo} alt="" className="w-full h-full object-cover" />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-4">
                            <div className="text-[10px] tracking-[0.3em] uppercase text-gold mb-1">vendidirect.it</div>
                            <div className="font-serif text-lg text-ink-50">{data.title}</div>
                        </div>
                    </div>
                )}

                <div className="border border-white/10 p-4 text-xs text-ink-100 mb-6 font-mono break-all">{text}</div>

                <div className="grid grid-cols-2 gap-2 mb-4">
                    {networks.map((n) => (
                        <a key={n.label} href={n.href} target="_blank" rel="noopener noreferrer" data-testid={`share-${n.label.toLowerCase().replace(/[^a-z]/g, "")}`} className="flex items-center justify-center gap-2 border border-white/15 px-4 py-3 text-sm text-ink-100 hover:border-gold hover:text-gold transition-colors">
                            <n.icon size={14} /> {n.label}
                        </a>
                    ))}
                </div>

                <button onClick={copy} data-testid="share-copy" className="w-full flex items-center justify-center gap-2 bg-gold text-black py-3 text-sm font-medium hover:bg-gold-soft transition-colors">
                    {copied ? <><Check size={14} /> Copiato!</> : <><Copy size={14} /> Copia testo + link</>}
                </button>
            </div>
        </div>
    );
}
